import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ResourceGrid, ResourceDetail } from '@/features/resources'
import type { ResourceItem } from '@/features/resources'
import { useGenerationFormStore } from '@/features/generation/store'
import { PageLayout } from '@/shared/components'

export function ResourcesPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [selectedItem, setSelectedItem] = useState<ResourceItem | null>(null)

  const handleUseInGeneration = useCallback(
    (item: ResourceItem) => {
      const store = useGenerationFormStore.getState()
      if (item.resource_type === 'checkpoint') {
        store.setCheckpoint(item.name)
      } else if (item.resource_type === 'lora') {
        store.addLora({ resource_id: item.id, weight: 1.0 })
      }
      void navigate('/')
    },
    [navigate],
  )

  return (
    <PageLayout title={t('resources.title')}>
      {selectedItem ? (
        <ResourceDetail
          item={selectedItem}
          onClose={() => setSelectedItem(null)}
          onUseInGeneration={handleUseInGeneration}
        />
      ) : (
        <ResourceGrid selectedType={null} onSelectResource={setSelectedItem} />
      )}
    </PageLayout>
  )
}
